import { render } from "./PageViewPSBditerimaPelunasan.vue?vue&type=template&id=737fc650"
import script from "./PageViewPSBditerimaPelunasan.vue?vue&type=script&lang=js"
export * from "./PageViewPSBditerimaPelunasan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__